module.exports = __webpack_public_path__ + "img/798.820aef99.png";